// Codifica ids de sub-hilos (mensajes sincronizados) para el parámetro `mt` de la URL
export const encodeUrlSafeBase64 = (value) => {
  try {
    return btoa(String(value))
      .replace(/\+/g, "-")
      .replace(/\//g, "_")
      .replace(/=+$/g, "");
  } catch (error) {
    return String(value);
  }
};

export const decodeUrlSafeBase64 = (value) => {
  if (!value) return null;

  const normalized = String(value).replace(/-/g, "+").replace(/_/g, "/");
  const padding = normalized.length % 4;
  const padded =
    padding === 0 ? normalized : `${normalized}${"=".repeat(4 - padding)}`;

  try {
    return atob(padded);
  } catch (error) {
    // Backward compatibility: if it is not encoded, keep original value.
    return String(value);
  }
};

export const INTERNAL_THREADS_ENDPOINT = "communication/threads/internal/";
export const INTERNAL_THREADS_PATH = "/gestion-interna/comunicacion";

export const buildInternalThreadUrl = (threadId, { messageThreadId, messageThreadTitle } = {}) => {
  const params = new URLSearchParams();
  if (messageThreadId) {
    params.set("mt", encodeUrlSafeBase64(messageThreadId));
    if (messageThreadTitle) params.set("mtt", messageThreadTitle.trim());
  }
  const query = params.toString();
  return `${INTERNAL_THREADS_PATH}/${threadId}${query ? `?${query}` : ""}`;
};
